import ReactOnRails from 'react-on-rails';

import Header from '../components/Header';
import AlbumListingImage from '../components/AlbumListingImage';
import AlbumListingImageWithFavorite from '../components/AlbumListingImageWithFavorite';
import Footer from '../components/Footer';
import IconAgent from '../components/IconAgent';
import FilterComponent from '../components/FilterComponent';
import Spinner from '../components/Spinner';
import HeroSection from '../components/HeroSection';
import UnionPagination from '../components/union-pagination';
import FavoriteStore from '../components/Favorite/store';

ReactOnRails.register({
  FavoriteStore,
  Header,
  AlbumListingImageWithFavorite,
  AlbumListingImage,
  Footer,
  IconAgent,
  FilterComponent,
  Spinner,
  HeroSection,
  UnionPagination,
});
